import { AppBar, Backdrop, Box, Divider, Grid } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import { useEffect, useState, memo } from 'react';
import { useViewportScroll, motion } from 'framer-motion';

import FreeSens from 'assets/img/homeLogo.svg';
import FaqIcon from 'assets/img/faqIcon.svg';
import NavCrmButton from 'modules/components/common/button/nav-crm-button';
import crmIcon from 'assets/img/crmcrm.svg';
import arrowSvg from 'assets/img/figmaArrow.svg';
import { useDoctorInfo } from 'modules/user/hooks/useDoctorInfo';
import { useAppType } from 'hooks/useAppType';
import { whatsappUrl } from 'utils/functions-utils';
import { useLocation } from 'react-router-dom';

const navStyles = {
  position: 'absolute',
  width: '100%',
  left: '0',
  zIndex: '1000'
};

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  '.MuiAccordion-root': {},
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  zIndex: '5',
  border: 'none !important',
  borderRadius: '0px 0px 20px 20px'
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<img src={arrowSvg} alt="" />} {...props} />
))(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'row-reverse',
  padding: '5px 12px 5px',
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(180deg)'
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)'
  }
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '0 0'
}));

export const MobileNavbar = memo(() => {
  const { pathname } = useLocation();
  const { data } = useDoctorInfo();
  const { data: appType, isLoadingAppType } = useAppType();

  const [expanded, setExpanded] = useState('');
  const [hidden, setHidden] = useState(false);

  const { scrollY } = useViewportScroll();

  const handleClose = () => {
    setExpanded(false);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    if (scrollY?.current < 30) setExpanded(newExpanded ? panel : false);
  };

  function update() {
    if (scrollY?.current < 30) {
      setHidden(false);
    } else if (scrollY?.current > 30) {
      setHidden(true);
    }
  }

  useEffect(() => {
    return scrollY.onChange(() => update());
  });

  const variants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: -25 }
  };

  useEffect(() => {
    if (expanded === 'panel1') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [expanded]);

  const hiddenPath = [
    '/app/report',
    '/authentication/login',
    '/authentication/crm',
    '/app/edit',
    '/app/scan'
  ].includes(pathname)
    ? true
    : false;

  return (
    <AppBar
      sx={{ zIndex: 150, display: { xs: hiddenPath && 'none', md: 'none' } }}
    >
      <motion.nav
        variants={variants}
        animate={hidden ? 'hidden' : 'visible'}
        transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.6 }}
        style={navStyles}
      >
        <Backdrop
          sx={{
            zIndex: '5',
            background: 'rgba(112, 112, 112, 0.60)'
          }}
          open={expanded === 'panel1'}
          onClick={handleClose}
        />
        <Accordion
          sx={{
            background:
              expanded === 'panel1'
                ? '#FFFFFF '
                : 'rgba(255, 255, 255, 0.8) !important'
          }}
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Grid container sx={{ alignItems: 'center' }}>
              <Grid item xs={appType?.isReleaseEnv ? 6 : 4}>
                <span
                  style={{
                    fontSize: '12px',
                    marginRight: '6px',
                    color: '#707070',
                    fontFamily: 'dana-bold'
                  }}
                >
                  دکتر {data?.firstName ? data?.firstName : ''}{' '}
                  {data?.lastName ? data?.lastName : ''}
                </span>
              </Grid>
              {!appType?.isReleaseEnv && (
                <Grid
                  item
                  xs={3.8}
                  sx={{
                    display: 'flex',
                    textAlign: '',
                    alignItems: 'flex-start',
                    justifyContent: 'center'
                  }}
                  style={{
                    fontSize: '12px',
                    color: '#707070',
                    fontFamily: 'dana-bold',
                    paddingTop: '3px'
                  }}
                >
                  {!isLoadingAppType && appType?.env}
                </Grid>
              )}
              <Grid
                item
                xs={appType?.isReleaseEnv ? 6 : 4.2}
                sx={{
                  display: 'flex',
                  textAlign: '',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end'
                }}
              >
                <img src={FreeSens} alt="FreeSens logo" />
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            margin={'0 !important'}
            sx={{
              padding: '15px 12px 16px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '0 0 16px',
                fontSize: '12px',
                color: '#707070',
                fontFamily: 'dana-bold'
              }}
            >
              <span>شماره نظام پزشکی : </span>
              <span
                style={{
                  color: ' #753CBE',
                  fontWeight: 400,
                  paddingTop: '2px',
                  marginRight: '10px'
                }}
              >
                {data?.medicalNumber}
              </span>
            </Box>
            <Divider sx={{ width: '100%', background: '#D8D8D8' }} />
            <NavCrmButton
              svg={crmIcon}
              label=" تماس با پشتیبانی"
              isExternalLink
            />
            <NavCrmButton
              svg={FaqIcon}
              label="سوالات متداول"
              navigateUrl={'/app/faq'}
              closeNavHandler={handleClose}
            />
          </AccordionDetails>
        </Accordion>
      </motion.nav>
    </AppBar>
  );
});
